/* hi-markt · Schnellansicht — Steuerung.
   Lag bis 2026-09-17 als Inline-<script> in snippets/hm-quickview-init.liquid und blockierte
   dort den HTML-Parser. Als eigene Datei mit `defer` blockiert sie nichts mehr und wird
   zwischen Seiten zwischengespeichert. Fenster-Markup und CSS bleiben im Snippet: das Markup,
   weil es sofort im HTML stehen muss, das CSS, weil es zum kritischen Pfad gehoert.
   Die Waechter-Variable `window.__hmQvWired` bleibt unveraendert — sie ist der Grund, warum
   ein zweites Einbinden (Theme-Editor, Hot-Reload) nichts doppelt verdrahtet. */
(function(){
  if(window.__hmQvWired) return;
  window.__hmQvWired = true;

  var modal = document.querySelector('[data-qv]');
  var scrim = document.querySelector('[data-qv-scrim]');
  var body  = document.querySelector('[data-qv-body]');
  if(!modal || !scrim || !body) return;

  var lastFocus = null, ctrl = null, variants = [], chosen = [];

  function open(){
    scrim.hidden = false; modal.hidden = false;
    /* KEIN requestAnimationFrame: in einem Hintergrund-Tab feuert rAF nicht — das Fenster
       bliebe unsichtbar, obwohl der Inhalt geladen ist. Ein erzwungener Reflow reicht, damit
       die Transition sauber von hidden nach sichtbar läuft, und ist immer synchron. */
    void modal.offsetWidth;
    scrim.classList.add('is--on'); modal.classList.add('is--on');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    modal.classList.remove('is--on'); scrim.classList.remove('is--on');
    document.body.style.overflow = '';
    setTimeout(function(){ modal.hidden = true; scrim.hidden = true; body.innerHTML = ''; }, 250);
    if(ctrl) ctrl.abort();
    /* Fokus zurück auf den Auslöser — sonst steht der Tastatur-Nutzer am Seitenanfang. */
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Fokusfalle: ein aria-modal-Dialog darf den Fokus nicht nach draussen lassen. */
  function trap(e){
    if(modal.hidden) return;
    if(e.key === 'Escape'){
      /* Erst die Vergrösserung schliessen, dann das Fenster — sonst verliert der Kunde
         mit einem Tastendruck mehr, als er wollte. */
      var z = modal.querySelector('[data-qv-zoomlayer]');
      if(z && !z.hidden){ z.hidden = true; return; }
      close();
      return;
    }
    /* Blättern per Pfeiltaste — nicht, während in einem Feld getippt wird.
       `e.target.matches` erst prüfen: das Ziel kann `document` sein (kein Element, keine
       matches-Methode) — ein direkter Aufruf wirft dort und legt den ganzen Handler lahm. */
    var inField = e.target && e.target.matches && e.target.matches('input,select,textarea');
    if((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !inField){
      e.preventDefault();
      step(e.key === 'ArrowRight' ? 1 : -1);
      return;
    }
    if(e.key !== 'Tab') return;
    var f = modal.querySelectorAll('a[href],button:not([disabled]),input,select,textarea');
    if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }

  function money(){ return null; }   /* Preise kommen fertig formatiert vom Server (money-Filter). */

  function readVariants(){
    var el = body.querySelector('[data-qv-variants]');
    try { variants = el ? JSON.parse(el.textContent) : []; } catch(e){ variants = []; }
    chosen = [];
    body.querySelectorAll('[data-qv-option]').forEach(function(b){
      if(b.classList.contains('is--on')) chosen[+b.dataset.qvOption] = b.dataset.qvValue;
    });
  }

  function matchVariant(){
    return variants.find(function(v){
      return chosen.every(function(c, i){ return c == null || v.options[i] === c; });
    });
  }

  function applyVariant(){
    var v = matchVariant();
    var idEl = body.querySelector('[data-qv-id]');
    var add = body.querySelector('[data-qv-add]');
    var addTx = body.querySelector('[data-qv-addtext]');
    var price = body.querySelector('[data-qv-price]');
    var old = body.querySelector('[data-qv-old]');
    var stock = body.querySelector('[data-qv-stock]');
    var stage = body.querySelector('[data-qv-stage-img]');
    var badge = body.querySelector('[data-qv-badge]');
    if(!v){
      if(add){ add.disabled = true; }
      if(addTx) addTx.textContent = 'Nicht verfügbar';
      return;
    }
    if(idEl) idEl.value = v.id;
    if(price){ price.textContent = v.price; price.classList.toggle('hm-qv__now--sale', v.pct > 0); }
    if(old){ old.textContent = v.compare; old.hidden = !(v.pct > 0); }
    var save = body.querySelector('[data-qv-save]');
    if(save){ save.textContent = 'Sie sparen ' + v.save; save.hidden = !(v.pct > 0); }
    if(badge){ badge.textContent = '−' + v.pct + ' %'; badge.hidden = !(v.pct > 0); }
    /* srcset gewinnt über src — ohne Entfernen bliebe bei den meisten Breiten das ALTE Bild stehen (wie der Thumb-Pfad es bereits macht). */
    if(stage && v.img){ stage.removeAttribute('srcset'); stage.src = v.img; }
    if(stock){
      stock.classList.toggle('is--off', !v.available);
      stock.lastChild.textContent = v.available ? 'Auf Lager · Kostenloser Versand' : 'Derzeit nicht verfügbar';
    }
    if(add) add.disabled = !v.available;
    if(addTx) addTx.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
    clampQty();
    markUnavailable();
  }

  /* Kombinationen ausgrauen, die es nicht (mehr) gibt.
     Die CSS-Regel `.hm-qv__val.is--off` war bisher totes Styling — niemand setzte die Klasse.
     Für jeden Wert prüfen: gäbe es MIT den übrigen Auswahlen eine lieferbare Variante?
     Nicht sperren, nur kennzeichnen: ein Klick darf weiter dorthin führen (dann zeigt der
     Knopf ehrlich „Ausverkauft"), statt den Kunden in einer Sackgasse festzuhalten. */
  function markUnavailable(){
    body.querySelectorAll('[data-qv-option]').forEach(function(btn){
      var i = +btn.dataset.qvOption;
      var val = btn.dataset.qvValue;
      var possible = variants.some(function(v){
        if(v.options[i] !== val) return false;
        return chosen.every(function(c, j){ return j === i || c == null || v.options[j] === c; });
      });
      var buyable = variants.some(function(v){
        if(v.options[i] !== val || !v.available) return false;
        return chosen.every(function(c, j){ return j === i || c == null || v.options[j] === c; });
      });
      btn.classList.toggle('is--off', possible && !buyable);
      if(possible && !buyable) btn.title = 'Mit dieser Auswahl nicht verfügbar';
      else btn.removeAttribute('title');
    });
  }

  /* Menge auf den echten Bestand deckeln. `max: 0` heisst „keine Grenze" (Artikel ohne
     Bestandsführung oder mit erlaubtem Überverkauf) — dann NICHT sperren. */
  function clampQty(){
    var q = body.querySelector('[data-qv-qty]');
    var hint = body.querySelector('[data-qv-qtyhint]');
    var v = matchVariant();
    if(!q || !v) return;
    var n = parseInt(q.value, 10) || 1;
    var max = Number(v.max) || 0;
    var capped = false;
    if(n < 1){ n = 1; }
    if(max > 0 && n > max){ n = max; capped = true; }
    q.value = n;
    if(hint) hint.hidden = !capped;
  }

  function showOk(){
    var wrap = document.createElement('div');
    wrap.className = 'hm-qv__ok';
    wrap.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
      + '<b>Zum Warenkorb hinzugefügt</b><span>Sie können weiter stöbern oder direkt zur Kasse.</span>'
      + '<span class="hm-qv__okbtns"><a href="/cart">Zum Warenkorb</a>'
      + '<button type="button" data-qv-continue>Weiter stöbern</button></span>';
    modal.appendChild(wrap);
  }

  /* Kopf-Zähler nachziehen — sonst zeigt der Warenkorb im Header eine veraltete Zahl. */
  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('[data-cart-count]').forEach(function(e){ e.textContent = c.item_count; });
        document.querySelectorAll('[data-cart-tt-price]').forEach(function(e){
          if(window.T4SThemeSP && window.T4SThemeSP.Currency) {
            try { e.textContent = window.T4SThemeSP.Currency.formatMoney(c.total_price); } catch(err){}
          }
        });
      }).catch(function(){});
  }

  /* Vorladen beim Hovern/Antippen: der Kunde zeigt schon Absicht, bevor er klickt.
     Die Antwort landet im Cache, das Fenster ist beim Klick praktisch sofort da.
     Der Cache lebt nur für diesen Seitenaufruf — Preise/Bestand bleiben damit frisch. */
  var cache = {};
  function qvUrl(url){ return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=hm-quickview'; }
  function prefetch(url){
    if(!url || cache[url]) return;
    cache[url] = fetch(qvUrl(url))
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
      .catch(function(e){ delete cache[url]; throw e; });   /* Fehlschlag nicht cachen */
  }

  /* ---------- Blättern zwischen den Produkten der Seite ----------
     Die Liste kommt frisch aus dem DOM: nach dem Filtern steht dort ein anderes Raster,
     eine einmal gemerkte Liste wäre dann falsch. */
  var current = null;
  function urls(){
    return Array.prototype.slice.call(document.querySelectorAll('[data-hm-qv]'))
      .map(function(b){ return b.getAttribute('data-hm-qv-url') || b.getAttribute('href'); })
      .filter(function(u, i, a){ return u && a.indexOf(u) === i; });   /* Suchlampe + Raster können dasselbe Produkt zeigen */
  }
  function updateNav(url){
    current = url;
    var list = urls(), i = list.indexOf(url);
    var prev = modal.querySelector('[data-qv-prev]'), next = modal.querySelector('[data-qv-next]');
    if(prev) prev.hidden = !(i > 0);
    if(next) next.hidden = !(i > -1 && i < list.length - 1);

    /* Positionsanzeige: „3 von 24" — sonst blättert der Kunde blind. Nur zeigen, wenn es
       überhaupt etwas zu blättern gibt. */
    var pos = modal.querySelector('[data-qv-pos]');
    if(pos){
      var show = i > -1 && list.length > 1;
      pos.hidden = !show;
      if(show) pos.textContent = (i + 1) + ' von ' + list.length;
    }

    /* Nachbarn vorladen: beim Blättern soll nichts hängen. Passiert nach dem Rendern,
       konkurriert also nicht mit der gerade angezeigten Anfrage. */
    if(i > -1){
      if(list[i + 1]) prefetch(list[i + 1]);
      if(list[i - 1]) prefetch(list[i - 1]);
    }
  }
  function step(dir){
    var list = urls(), i = list.indexOf(current);
    if(i < 0) return;
    var t = list[i + dir];
    if(t) load(t);
  }

  function load(url){
    if(ctrl) ctrl.abort();
    ctrl = new AbortController();
    body.innerHTML = '<div class="hm-qv__load">Wird geladen …</div>';
    open();
    (cache[url] || fetch(qvUrl(url), {signal: ctrl.signal})
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); }))
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-qv-root]');
        if(!root) throw new Error('Antwort ohne Inhalt');
        body.innerHTML = '';
        body.appendChild(document.importNode(root, true));
        readVariants();
        var f = modal.querySelector('a[href],button:not([disabled])');
        if(f) f.focus();
        clampQty();
        /* Nicht lieferbare Kombinationen SOFORT kennzeichnen. markUnavailable() hängt sonst nur
           an applyVariant() — das läuft erst beim Klick auf eine Option, der Kunde sähe die
           Kennzeichnung also nie beim Öffnen. */
        markUnavailable();
        /* Merken-Zustand am nachgeladenen Herz anzeichnen (Kalles kennt das Markup noch nicht). */
        if(window.hmWishlistSync) window.hmWishlistSync();
        updateNav(url);
        var t = body.querySelector('.hm-qv__title');
        var say = document.querySelector('[data-qv-say]');
        if(say && t) say.textContent = 'Schnellansicht geöffnet: ' + t.textContent.trim();
      })
      .catch(function(e){
        if(e.name === 'AbortError') return;
        /* Ehrlich: keine leere Huelle zeigen, sondern den Weg zur Produktseite. */
        body.innerHTML = '<div class="hm-qv__err">Die Schnellansicht konnte nicht geladen werden.'
          + '<a href="' + url + '">Zur Produktseite</a></div>';
      });
  }

  /* Absicht erkennen, bevor geklickt wird — delegiert, damit es auch für neu gerenderte
     Karten (Filtern) gilt. `capture`, weil mouseenter/focus nicht blubbern. */
  ['mouseenter', 'touchstart', 'focusin'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      var b = e.target.closest && e.target.closest('[data-hm-qv]');
      if(b) prefetch(b.getAttribute('data-hm-qv-url') || b.getAttribute('href'));
    }, {capture: true, passive: true});
  });

  /* Auslöser: die Karten-Buttons (auch nach dem Neu-Rendern des Rasters — delegiert). */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-hm-qv]');
    if(btn){
      e.preventDefault();
      lastFocus = btn;
      load(btn.getAttribute('data-hm-qv-url') || btn.getAttribute('href'));
      return;
    }
    if(e.target.closest('[data-qv-close]') || e.target === scrim){ close(); return; }
    if(e.target.closest('[data-qv-continue]')){
      var ok = modal.querySelector('.hm-qv__ok');
      if(ok) ok.remove();
      close();
      return;
    }
    var val = e.target.closest('[data-qv-option]');
    if(val && modal.contains(val)){
      var i = +val.dataset.qvOption;
      val.parentElement.querySelectorAll('[data-qv-option]').forEach(function(b){ b.classList.remove('is--on'); });
      val.classList.add('is--on');
      chosen[i] = val.dataset.qvValue;
      var lbl = body.querySelector('[data-qv-optval="' + i + '"]');
      if(lbl) lbl.textContent = val.dataset.qvValue;
      applyVariant();
      return;
    }
    var th = e.target.closest('[data-qv-thumb]');
    if(th && modal.contains(th)){
      body.querySelectorAll('[data-qv-thumb]').forEach(function(b){ b.classList.remove('is--on'); });
      th.classList.add('is--on');
      var stage = body.querySelector('[data-qv-stage-img]');
      if(stage){ stage.src = th.dataset.full; stage.removeAttribute('srcset'); }
      /* Der Zoom muss dem gewählten Bild folgen — sonst vergrössert er weiter das erste. */
      var zoomBtn = body.querySelector('[data-qv-zoom]');
      if(zoomBtn && th.dataset.zoom) zoomBtn.setAttribute('data-full', th.dataset.zoom);
      return;
    }
    var pm = e.target.closest('[data-qv-minus],[data-qv-plus]');
    if(pm && modal.contains(pm)){
      var q = body.querySelector('[data-qv-qty]');
      var n = parseInt(q.value, 10) || 1;
      n += pm.hasAttribute('data-qv-plus') ? 1 : -1;
      q.value = Math.max(1, n);
      clampQty();
      return;
    }

    /* Bild vergrössern / schliessen */
    var zb = e.target.closest('[data-qv-zoom]');
    if(zb && modal.contains(zb)){
      var layer = modal.querySelector('[data-qv-zoomlayer]');
      var big = modal.querySelector('[data-qv-zoomimg]');
      var stage = body.querySelector('[data-qv-stage-img]');
      if(layer && big){
        big.src = zb.getAttribute('data-full') || (stage && stage.src);
        big.alt = stage ? stage.alt : '';
        layer.hidden = false;
      }
      return;
    }
    if(e.target.closest('[data-qv-zoomclose]') || e.target.closest('[data-qv-zoomimg]')){
      var l = modal.querySelector('[data-qv-zoomlayer]');
      if(l) l.hidden = true;
      return;
    }

    if(e.target.closest('[data-qv-prev]')){ step(-1); return; }
    if(e.target.closest('[data-qv-next]')){ step(1); return; }
  });

  /* Tippen in das Mengenfeld ebenfalls deckeln (nicht nur die +/−-Knöpfe). */
  document.addEventListener('input', function(e){
    if(e.target.matches('[data-qv-qty]') && modal.contains(e.target)) clampQty();
  });

  /* In den Warenkorb — ohne Seitenwechsel, mit ehrlicher Fehlermeldung. */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-qv-form]');
    if(!form || !modal.contains(form)) return;
    e.preventDefault();
    var add = form.querySelector('[data-qv-add]');
    var tx = form.querySelector('[data-qv-addtext]');
    var before = tx ? tx.textContent : '';
    if(add) add.disabled = true;
    if(tx) tx.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        id: form.querySelector('[data-qv-id]').value,
        quantity: parseInt(form.querySelector('[data-qv-qty]').value, 10) || 1
      })
    })
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description || d.message || 'Fehler'); return d; }); })
      .then(function(){ refreshCart(); showOk(); })
      .catch(function(err){
        if(tx) tx.textContent = String(err.message || 'Nicht möglich').slice(0, 60);
        setTimeout(function(){ if(tx) tx.textContent = before; if(add) add.disabled = false; }, 2600);
      });
  });

  document.addEventListener('keydown', trap);

  /* ---------- Wischen auf dem Bild (Touch) ----------
     Auf dem Handy sind die Thumbs klein; wischen ist die erwartete Geste. Nur horizontale
     Bewegungen zählen — sonst würde jedes Scrollen im Fenster Bilder umschalten. */
  (function(){
    var x0 = null, y0 = null;
    function stage(){ return body.querySelector('.hm-qv__stage'); }
    modal.addEventListener('touchstart', function(e){
      if(!e.target.closest || !e.target.closest('.hm-qv__stage')) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, {passive: true});
    modal.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;   /* zu kurz oder eher vertikal */
      var thumbs = Array.prototype.slice.call(body.querySelectorAll('[data-qv-thumb]'));
      if(thumbs.length < 2) return;
      var i = thumbs.findIndex(function(t){ return t.classList.contains('is--on'); });
      if(i < 0) i = 0;
      var n = dx < 0 ? i + 1 : i - 1;                                 /* nach links = weiter */
      if(n < 0 || n >= thumbs.length) return;                         /* an den Enden nicht umlaufen */
      thumbs[n].click();
    }, {passive: true});
  })();
})();
